import React from "react";
import moment from "moment-jalaali";
import {
  LineChart,
  Line,
  Tooltip,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Legend
} from 'recharts';

export default props => {
  const { data, label, color, formatter, ...rest } = props;
  if (!data) return null;
  return (
    <ResponsiveContainer
      width="100%"
      aspect={4.0 / 2.0}
      {...rest}
    >
      <LineChart
        margin={{
          top: 20,
          right: 0,
          left: 0,
          bottom: 0
        }}
        width={400}
        height={200}
        data={data.map(
          point => ({
            value: point.value,
            label: label,
            date: moment(point.key).format('jYYYY-jM-jD')
          })
        )}
        syncId="recommenderCharts"
      >
        <XAxis
          dataKey="date"
          padding={{ left: 30, right: 30 }}
          style={{ display: 'none' }}
        />
        <YAxis
          tickFormatter={formatter}
        />
        <Legend verticalAlign="top" height={36} />
        <Line
          name={label}
          type="linear"
          dataKey="value"
          stroke={color}
          strokeWidth={2}
        />
        <Tooltip
          content={({ active, payload, label }) => (
            <div>
              {active && payload && payload[0] && (
                <div
                  className="recharts-default-tooltip text-left"
                  style={{
                    backgroundColor: payload[0].fill,
                    color: payload[0].stroke,
                    border: `1px solid ${
                      payload[0].stroke
                      }`,
                    padding: 20
                  }}
                  key={payload[0].label}
                >
                  <span>{label}</span>
                  <h6>
                    {formatter ? formatter(payload[0].payload.value) : payload[0].payload.value}
                  </h6>
                </div>
              )}
            </div>
          )
          }
        />
      </LineChart>
    </ResponsiveContainer>
  )
}